import { useState, useEffect } from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormInput, FormDropDownListFilter, FormDatePicker } from "../FormComponents";
import { requiredValidator } from "../Validators";
import { PostTool } from "../../../data/interfaces";
import { getEmployees } from "../../../data/employeeData";

interface AddToolFormProps {
  onToolSubmit: (tool: PostTool) => void;
  onErrorMessage?: string | null;
}

const AddToolForm = ({ onToolSubmit, onErrorMessage }: AddToolFormProps) => {
  const [employees, setEmployees] = useState<any[]>([]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const employeeData = await getEmployees();
        const formattedEmployees = employeeData
          .map((emp: any) => ({
            value: emp.employeeId,
            text: emp.employeeName,
          }))
          .sort((a: any, b: any) => a.text.localeCompare(b.text));
        setEmployees(formattedEmployees);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };
    fetchEmployees();
  }, []);

  const handleSubmit = (dataItem: any) => {
    const setTimeTo3AM = (date: Date | null) => {
      if (!date) return null;
      const newDate = new Date(date);
      newDate.setHours(3, 0, 0, 0);
      return newDate.toISOString();
    };

    const formattedData: PostTool = {
      make: dataItem.make || null,
      model: dataItem.model || null,
      serialNo: dataItem.serialNo || null,
      lastCalibrated: setTimeTo3AM(dataItem.lastCalibrated),
      nextCalibration: setTimeTo3AM(dataItem.nextCalibration),
      employeeId: dataItem.employeeId?.value || null,
    };
    onToolSubmit(formattedData);
  };

  return (
    <div className="form__container">
      <Form
        onSubmit={handleSubmit}
        initialValues={{
          make: "",
          model: "",
          serialNo: "",
          lastCalibrated: null,
          nextCalibration: null,
          employeeId: null,
        }}
        render={(formRenderProps) => (
          <FormElement style={{ padding: '1rem', width: '100%', marginBottom: '5rem' }}>
            <fieldset className="k-form-fieldset">
              <legend className="k-form-legend">Tool Details</legend>

              <Field
                name="make"
                component={FormInput}
                label="Make *"
                validator={requiredValidator}
              />

              <Field
                name="model"
                component={FormInput}
                label="Model"
              />

              <Field
                name="serialNo"
                component={FormInput}
                label="Serial No"
              />

              <Field
                name="lastCalibrated"
                component={FormDatePicker}
                label="Last Calibrated"
              />

              <Field
                name="nextCalibration"
                component={FormDatePicker}
                label="Next Calibration"
              />

              <Field
                name="employeeId"
                component={FormDropDownListFilter}
                label="Assigned Employee"
                data={employees}
                textField="text"
                dataItemKey="value"
              />
            </fieldset>

            {onErrorMessage && (
              <div style={{ color: "red", marginTop: "1rem" }}>
                {onErrorMessage}
              </div>
            )}

            <div className='button__container'>
              <button
                type="submit"
                disabled={!formRenderProps.allowSubmit}
                className='form__edit__button accept'
              >
                Add Tool
              </button>
            </div>
          </FormElement>
        )}
      />
    </div>
  );
};

export default AddToolForm;
